import styled from 'styled-components'

export const Wrapper = styled.div`
  height: calc(100% - 75px);
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  justify-content: center;
`
export const WrapperFilters = styled.div`
  padding: 15px 20px;
  display: flex;
  flex-direction: column;
  width: -webkit-fill-available;

  .react-multi-email{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
`
export const WrapperActions = styled.div`
  display: flex;
  position: absolute;
  bottom: 15px;
  justify-content: space-around;
  border-top: solid var(--color-neutral-300) 1px;
  padding-top: 15px;

  button{
    width: 200px;
  }
`
